import React, { useId } from 'react';

/**
 * Wind 品牌 Logo（SVG + CSS 动画）
 * variant: nav | login | mark
 */
function WindLogo({ variant = 'nav', className = '' }) {
  const isMark = variant === 'mark';
  const uid = useId().replace(/:/g, '');
  const gradId = `wind-logo-grad-${uid}`;

  return (
    <span
      className={['wind-logo', `wind-logo--${variant}`, className].filter(Boolean).join(' ')}
    >
      <svg
        className="wind-logo__svg"
        viewBox={isMark ? '0 0 40 40' : '0 0 96 28'}
        role="img"
        aria-label="WIND"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>WIND</title>
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#60a5fa" />
            <stop offset="100%" stopColor="#7ec0ff" />
          </linearGradient>
        </defs>

        {isMark && (
          <>
            <circle className="wind-logo__halo" cx="20" cy="20" r="17" fill={`url(#${gradId})`} />
            <circle className="wind-logo__orbit" cx="20" cy="20" r="13.5" />
          </>
        )}

        <g className="wind-logo__breeze">
          <path
            className="wind-logo__streak wind-logo__streak--1"
            stroke={isMark ? '#fff' : `url(#${gradId})`}
            d={isMark ? 'M8 22 C14 15, 20 15, 28 20' : 'M0 18 C6 11, 12 11, 20 17'}
          />
          <path
            className="wind-logo__streak wind-logo__streak--2"
            stroke={isMark ? '#fff' : `url(#${gradId})`}
            d={isMark ? 'M8 26 C15 18, 21 20, 30 25' : 'M0 22 C7 15, 13 17, 22 21'}
          />
          <path
            className="wind-logo__streak wind-logo__streak--3"
            stroke={isMark ? '#fff' : `url(#${gradId})`}
            d={isMark ? 'M8 17 C13 12, 19 13, 27 11' : 'M0 14 C5 8, 12 10, 20 10'}
          />
          {isMark && <circle className="wind-logo__core" cx="10" cy="20" r="1.6" />}
        </g>

        {!isMark && (
          <text x="26" y="20" className="wind-logo__word">
            <tspan className="wind-logo__letter wind-logo__letter--w">W</tspan>
            <tspan className="wind-logo__letter wind-logo__letter--i">I</tspan>
            <tspan className="wind-logo__letter wind-logo__letter--n">N</tspan>
            <tspan className="wind-logo__letter wind-logo__letter--d">D</tspan>
          </text>
        )}
      </svg>
    </span>
  );
}

export default WindLogo;
